import styled from 'styled-components'

export const CardTitle = styled.h2`
  font-size: 34px;
`